import React from 'react';
import StarRating from '@/components/admin/TestimonialStars';
import { SOURCE_STYLES } from '@/components/admin/testimonialUtils';

const ReviewCard = ({ testimonial }) => {
  const sourceClass = SOURCE_STYLES[testimonial.source] || SOURCE_STYLES.Other;
  return (
    <div className="bg-white border border-gray-100 border-t-4 border-t-[#E8651A] shadow-sm rounded-2xl p-6">
      <div className="flex items-center justify-between gap-3 mb-4">
        <div className="[&_svg]:text-[#F5B230] [&_svg]:fill-[#F5B230]">
          <StarRating value={testimonial.rating} readonly size={16} />
        </div>
        {testimonial.source && (
          <span className={`text-[11px] font-medium px-2.5 py-0.5 rounded-full font-body ${sourceClass}`}>
            {testimonial.source}
          </span>
        )}
      </div>
      <p className="font-body text-[#555] mb-4 text-sm leading-relaxed">
        {testimonial.review_text}
      </p>
      <p className="font-body font-bold text-[#1B2D5E] text-sm">
        {testimonial.customer_name}
      </p>
      {testimonial.route && (
        <p className="font-body text-xs text-gray-400 mt-0.5">
          {testimonial.route}
        </p>
      )}
      {testimonial.travel_month && (
        <p className="font-body text-xs text-gray-400">
          {testimonial.travel_month}
        </p>
      )}
      <span className="inline-flex items-center gap-1 text-[10px] text-green-600 font-semibold bg-green-50 px-2 py-0.5 rounded-full mt-1">
        ✓ Verified Customer
      </span>
    </div>
  );
};

const SkeletonCard = () => (
  <div className="testimonial-skeleton bg-white border border-gray-100 border-t-4 border-t-[#E8651A] shadow-sm rounded-2xl p-6 min-h-[200px]">
    <div className="h-4 w-24 bg-[#EBEBEB] rounded mb-4 animate-pulse" />
    <div className="space-y-2 mb-6">
      <div className="h-3 bg-[#F0F0F0] rounded animate-pulse" />
      <div className="h-3 bg-[#F0F0F0] rounded animate-pulse w-5/6" />
      <div className="h-3 bg-[#F0F0F0] rounded animate-pulse w-4/6" />
    </div>
    <div className="h-3 w-32 bg-[#EBEBEB] rounded animate-pulse" />
  </div>
);

const AtithiReviewsSection = ({ testimonials, loading }) => {
  if (loading) {
    return (
      <section className="section-outer section-standard bg-[#F8F4EE] mb-0" data-aos="fade-up">
        <div className="section-inner">
          <div className="mb-10">
            <p className="section-label">CUSTOMER REVIEWS</p>
            <h2 className="section-heading mt-2">What Our Customers Say</h2>
          </div>
          <div className="grid-reviews-3">
            <SkeletonCard />
            <SkeletonCard />
            <SkeletonCard />
          </div>
        </div>
      </section>
    );
  }

  if (!testimonials.length) return null;

  return (
    <section className="section-outer section-standard bg-[#F8F4EE] mb-0" data-aos="fade-up">
      <div className="section-inner">
        <div className="mb-10">
          <p className="section-label">CUSTOMER REVIEWS</p>
          <h2 className="section-heading mt-2">What Our Customers Say</h2>
        </div>
        <div className="grid-reviews-3">
          {testimonials.map((t) => (
            <ReviewCard key={t.id} testimonial={t} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default AtithiReviewsSection;
